<template>
  <div class="welcome hero">
        <div class="wrap-banner">
          <div class="main-title">
            <article>          
              <h3 data-aos="fade" data-aos-delay="500">Hi, I'm Alex Webb.</h3>
              <p data-aos="fade-up" data-aos-delay="1000">I'm a full stack web developer from Bristol, UK.</p>
              <p data-aos="fade-up" data-aos-delay="2000">I build websites and .Net applications.</p>
            </article>
          </div>
          
          <vue-particles
            color="#ffffff"
            :particleOpacity="0.7"
            linesColor="#ffffff"
            :particlesNumber="80"
            shapeType="circle"
            :particleSize="5"
            :linesWidth="2"
            :lineLinked="true"
            :lineOpacity="0.4"
            :linesDistance="150"
            :moveSpeed="3"
            :hoverEffect="true"
            hoverMode="grab"
            :clickEffect="true"
            clickMode="push"
          >          
          </vue-particles>
        </div>
        <div id="scroll-container">
          <a href="#" id="welcome-scroll" class="arrow down" v-scroll-to="'#projects'"></a>
        </div>
    
  </div>
</template>

<script>

export default {
  name: 'Welcome',
  components: {
  },
  props: {    
  },
  methods: {
  },
  beforeMount(){
 },
}

</script>

<style scoped>
p{margin-top: 40px;}
.welcome{
  background-color: #fff;
  background-image: url('../assets/2014_earth_from_space.jpg');
  /* background-position: center; */
  color: #fff;
  overflow: hidden;
}
.hero{
  height: 100vh;
}
article{
  width: 100%;
  padding-top:50px;
}
#scroll-container {
    width: 100%;
    position: absolute;
    bottom: 40px;
}
.arrow{
  width: 45px;
    height: 45px;
    display: inline-block;
    border-left: 3px solid red;
    border-bottom: 3px solid red;
    -webkit-animation: bounce 2s infinite;
    animation: bounce 2s infinite;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
}
@keyframes bounce {
  0% {
        -webkit-transform: rotate(-45deg) translate(0, 0);
        transform: rotate(-45deg) translate(0, 0)
    }

    20% {
        -webkit-transform: rotate(-45deg) translate(-10px, 10px);
        transform: rotate(-45deg) translate(-10px, 10px)
    }

    40% {
        -webkit-transform: rotate(-45deg) translate(0, 0);
        transform: rotate(-45deg) translate(0, 0)
    }
}
.wrap-banner {
    position: relative;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-flex;
    display: flex;
    height: 100%;
    justify-content: center;
    background-color: rgba(55,130,210, 0.6)
  }
  .main-title {
    color: #fff;
    z-index: 999;    
  }
  #particles-js{
    position: absolute;
    width:100%;
    height: 100%;
    opacity: 0.3;
  }
</style>
